export default __webpack_public_path__ + "static/media/petal-flower.2bc17ffe.gif";